// extracted by mini-css-extract-plugin
export var sliderRange = "_r4-2";
export var sliderRoot = "_r4-0";
export var sliderThumb = "_r4-3";
export var sliderTrack = "_r4-1";